import React from "react";
import { useSector } from "./SectorContext";
import { useNavigate } from "react-router-dom";
import useState from "react";

function SectionText() {

  const {activeSector} = useSector() 

  const navigate =  useNavigate()
  return (
    <>

<div className="text-bumper-wrapper">
  {/* {activeSector.bumperText.split(" ").slice(0, Math.ceil(activeSector.bumperText.split(" ").length / 2)).join(" ")} */}
  {activeSector.bumperText[0]}
  <strong className={activeSector.colorClass}>
    {/* {activeSector.bumperText.split(" ").slice(Math.ceil(activeSector.bumperText.split(" ").length / 2)).join(" ")} */}
    {activeSector.bumperText[1]}
  </strong>
</div>


    </>
  );
}

export default SectionText;
